/* eslint-disable @typescript-eslint/naming-convention */

export enum Table {
  ROW,
  COL
}
